import Routes from "./routes/Routes";
import { Suspense, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useWebSocket from "./hooks/useWebSocket";
import "./assets/stylesheet/style1.css";
import { API_URL } from "./network";

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve Kiosk ID from local storage
  const kiosk = localStorage.getItem("Kiosk")?.replace(/"/g, "").trim();
  //console.log("-----------------------------------------------------------------------------kioskid",kiosk);
  // Get WebSocket maintenance data
  const { kioskMaintenanceStatus, isGlobalMaintenance } = useWebSocket(
    "https://localhost:44373/ws"
  );

  useEffect(() => {
    //console.log("---------------------------------------------------Global Maintenance:", isGlobalMaintenance);
    //console.log("---------------------------------------------------Kiosk:", kiosk);
    if (isGlobalMaintenance) {
      //console.log("🔴 Global Maintenance Active - Redirecting to Maintenance Page...");
      localStorage.setItem("isMaintenance", "true");
      if (location.pathname !== "/maintenance") {
        navigate("/maintenance");
      }
      return; // Ensure no further execution
    }
    // If kiosk is not logged in, stay on the login page
    if (!kiosk) {
      //console.log("No kiosk found. Staying on the login page.");
      return;
    }
    // Check if this kiosk is under maintenance
    const isKioskUnderMaintenance = kiosk && kioskMaintenanceStatus[kiosk];

    if (isGlobalMaintenance || isKioskUnderMaintenance) {
      localStorage.setItem("isMaintenance", "true");
      if (location.pathname !== "/maintenance") {
        navigate("/maintenance");
      }
    } else {
      localStorage.setItem("isMaintenance", "false");
      if (location.pathname === "/maintenance") {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
        window.history.replaceState({}, document.title, "/");
      }
    }
  }, [isGlobalMaintenance, kioskMaintenanceStatus, kiosk, location, navigate]);

  useEffect(() => {
    if (
      !(
        API_URL.includes("localhost") ||
        API_URL.includes("192.168.52.") ||
        API_URL.includes("192.168.50.")
      )
    ) {
      const disableContext = (e) => e.preventDefault();
      document.addEventListener("contextmenu", disableContext);
      document.addEventListener("selectstart", disableContext);
      return () => {
        document.removeEventListener("contextmenu", disableContext);
        document.removeEventListener("selectstart", disableContext);
      };
    }
  }, []);

  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default function WrappedApp() {
  return (
    <Suspense fallback="...loading">
      <App />
    </Suspense>
  );
}
